module.exports = __webpack_public_path__ + "static/media/trip.0cc4c9e1.svg";